// Import Plugin/Modules
import Overlay from './vendor/overlay.js';
import Menu from './vendor/menu.js';
import baguetteBox from 'baguettebox.js';
import jQuery from "jquery";
import "jquery.cookie";
import "slick-carousel";
window.$ = window.jQuery = jQuery;

new Overlay('.js-overlay', '.js-overlay-toggle', {
    class_open_body: 'overlay-open' // Class applied to body when active
})

var menu = new Menu('js-menu');

// alert
if (typeof $.cookie('hide_alert') === 'undefined'){
    $( ".Header-message" ).show();
} else {
    $( ".Header-message" ).hide();
}
$( ".Header-message_close" ).click(function() {
    $( ".Header-message" ).hide();
    $.cookie("hide_alert", 1, { expires: 7 });
});

// splash slider
$(".Splash-main_slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 8000
});

// smooth scrolling
$(document).on('click', 'a.smooth', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});

// baguetteBox
baguetteBox.run('.js-gallery');

// sliding gallery
$(".js-gallery-slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    dots: false,
    arrows: false,
    speed: 1000,
    autoplaySpeed: 8000,
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            }
        }
    ]
});

// faqs
// $('.ContentEntryShow-faqs_section-faqs').hide();
$('.ContentEntryShow-faqs_section h3').click(function() {
    if($(this).next('.ContentEntryShow-faqs_section-faqs').is(':visible')) {
        $(this).next('.ContentEntryShow-faqs_section-faqs').slideUp();
        $(this).removeClass('active');
    } else {
        $(this).next('.ContentEntryShow-faqs_section-faqs').slideDown();
        $(this).addClass('active');
    }
});


// var allPanels = $('.jq-faqs > .jq-faq > p').hide();
//
// $('.first-section .jq-faq.first-faq > p').show();
//
// $('.jq-faqs > .jq-faq > h5').click(function() {
//     allPanels.slideUp();
//     $(this).next().slideDown();
//     return false;
// });
//
